import React from "react";
import { deleteIcon } from "../../utils/config";
import type { DeleteButtonModel } from "../../type/buttons";
import "./deleteButton.scss";


const DeleteButton: React.FC<DeleteButtonModel> = ({
  onClick,
  title = "Delete",
  className = "",
  disabled = false,
  ariaLabel,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick(e);
  };

  return (
    <span className="delete-button-wrapper">
        <button
        type="button"
        className={`delete-button ${className}`.trim()}
        onClick={handleClick}
        title={title}
        aria-label={ariaLabel || title}
        disabled={disabled}
        >
        {deleteIcon}
        </button>
    </span>
  );
};

export default DeleteButton;